'use client'
import React, { useEffect } from 'react'
import { Crisp } from 'crisp-sdk-web'

const CRISP_WEBSITE_ID = 'af9adec5-ddfa-4db9-a4a3-25769daf2fc2'

export default function CrispChat() {
  useEffect(() => {
    Crisp.configure(CRISP_WEBSITE_ID)
    Crisp.session.setSegments(['stellate'], true)
  })

  return null
}

export function OpenCrispChatButton({
  children = 'Open live chat',
  className = 'inline-flex items-center justify-center h-10 px-4 rounded-8 font-demibold text-15 leading-none bg-blue text-white transition-opacity hover:opacity-90',
}: {
  children?: React.ReactNode
  className?: string
}) {
  const openChat = () => {
    Crisp.chat.show()
    Crisp.chat.open()
  }

  return (
    <button type='button' onClick={openChat} className={className}>
      {children}
    </button>
  )
}
